import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "../../axiosClient/userApi";
import { TagType, TagTypeFormData } from "../../../types/tag";

export const useCreateTagType = () => {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (data: TagTypeFormData): Promise<TagType> => {
            const response = await loggedInApiCall.post("/api/tag_types", data);
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries(["getAllTagTypes"]);
        },
    });

    return mutation;
};
